import { motion } from "framer-motion";

const headerInitial = { opacity: 0, y: 28 };
const headerInView = { opacity: 1, y: 0 };
const headerViewport = { once: true, margin: "-80px" };
const headerTransition = { duration: 0.7, ease: [0.22, 1, 0.36, 1] };

export function SectionHeader({ eyebrow, title, description, testId }) {
  return (
    <motion.div
      initial={headerInitial}
      whileInView={headerInView}
      viewport={headerViewport}
      transition={headerTransition}
      className="mb-12 grid gap-6 border-b border-industrial-line pb-8 lg:grid-cols-[0.7fr_1.3fr] lg:items-end"
      data-testid={testId}
    >
      <p className="font-mono text-xs font-semibold uppercase tracking-[0.28em] text-industrial-yellow">
        {eyebrow}
      </p>
      <div>
        <h2 className="font-heading text-3xl font-bold uppercase leading-[0.95] tracking-tight text-industrial-text sm:text-4xl lg:text-5xl">
          {title}
        </h2>
        {description && <p className="mt-5 max-w-3xl text-sm leading-7 text-industrial-muted sm:text-base">{description}</p>}
      </div>
    </motion.div>
  );
}
